// extracted by mini-css-extract-plugin
export default {"wrapper":"Wo-z","response":"Xo-z","error":"Yo-z","disabled":"Zo-z","buttons":"_o-z","feedbackQuestionSection":"ap-z","yesNoWrapper":"bp-z"};